/*
 * @Author: WLL
 * @Date: 2020-04-29 14:02:45
 * @LastEditors: WLL
 * @LastEditTime: 2020-05-01 12:49:28
 * @Description: 接口定义
 */
import Base from "./Base";
import Home from "./Home";
import Org from "./Organization";
import Analyst from "./Analyst";
import Industry from "./Industry";
import Stock from "./Stock";
import ReportDetail from "./ReportDetail";

export default {
  Base,
  Home,
  Org,
  Analyst,
  Industry,
  Stock,
  ReportDetail
};
